import type { RouteLocationNormalized, Router } from "vue-router";

export const vendorRouteName = {
  index: "vendors.index",
  show: "vendors.show",
};

export const vendorRoute = [
  {
    path: "/vendors",
    name: vendorRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "vendor_entity",
      breadcrumbs: () => {
        return [{ title: "Vendor" }];
      },
    },
  },
  {
    path: "/vendors/:id",
    name: vendorRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "vendor_entity",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: vendorRouteName.index }).path, title: "Vendor" }, { title: "Detail" }];
      },
    },
  },
];
